import React from 'react'
import { useTranslation } from 'react-i18next'

import { Project } from '@/schemas'

import {
  UserResourceDashboardContentCard,
  UserResourceDashboardLayout,
} from '../../../../components/user-resource-dashboard/dashboard-layout'
import { ProjectTrendPeopleDashboardCard } from './project-resource-people-trend-dashboard'
import { ProjectTrendProjectDashboardCard } from './project-resource-project-trend-dashboard'

export const ProjectResourceDashboard: React.FC<{ selfId: string; project: Project }> = ({ selfId, project }) => {
  const { t } = useTranslation()

  return (
    <UserResourceDashboardLayout>
      <UserResourceDashboardContentCard title={t('资源趋势')}>
        <ProjectTrendProjectDashboardCard selfId={selfId} />
        <ProjectTrendPeopleDashboardCard selfId={selfId} project={project} />
      </UserResourceDashboardContentCard>
    </UserResourceDashboardLayout>
  )
}
